// Importing all pages
import Login from "./Login/Index.vue";
import Home from "./Home/Index.vue";
import Users from "./Users/Index.vue";
import Information from "./Information/Index.vue";
import LoanOfficers from "./Loan-Officers/Dashboard.vue"
import Licenses from "./Licenses/Index.vue";
import Services from "./Services/Index.vue";
import OptOut from "./OptOut/Request";
import Know from "./Know/Request";
import Delete from "./Delete/Request";

export default {
   Login,
   Home,
   Users,
   Information,
   LoanOfficers,
   Licenses,
   Services,
   OptOut,
   Know,
   Delete
}